import { create } from 'zustand';

interface AuthState {
  accessToken: string | null;
  role: string | null;
  userName: string | null;
  isAuthenticated: boolean;
  setAuth: (token: string, role: string) => void;
  clearAuth: () => void;
}

function nameFromToken(token: string): string | null {
  try {
    const p = JSON.parse(atob(token.split('.')[1])) as Record<string, string>;
    return p.name ?? p.email ?? null;
  } catch {
    return null;
  }
}

export const useAuthStore = create<AuthState>((set) => ({
  accessToken: null,
  role: null,
  userName: null,
  isAuthenticated: false,
  setAuth: (accessToken, role) =>
    set({ accessToken, role, userName: nameFromToken(accessToken), isAuthenticated: true }),
  clearAuth: () => set({ accessToken: null, role: null, userName: null, isAuthenticated: false }),
}));
